import React from 'react';
import { isNil } from 'lodash';
import Anchor from '../Anchor';
import { setDetailPageUrl } from '../../../lib/common';
import { PRODUCT_DETAIL_URL_PATH } from '../../../constants/service/common/urlConstants';

const OpenProductDetail = (props) => {
  const { text, productId } = props;

  /**
   * 링크로 연결할 데이터가 없다면
   * '-' 를 반환함
   */
  if (isNil(text) && isNil(productId)) {
    return <>-</>;
  }

  return (
    <Anchor
      text={text}
      isUnderLine
      color="primary"
      href={setDetailPageUrl(PRODUCT_DETAIL_URL_PATH, productId)}
      target="_blank"
    />
  );
};

export default OpenProductDetail;
